import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import selectors from 'selectors'
import supplierActions from 'actions/suppliers'
import locationGroupActions from 'actions/locationGroups'
import locationActions from 'actions/locations'
import userActions from 'actions/users'
import tenantActions from 'actions/tenants'
import customerActions from 'actions/customers'
import Component from 'components/Rfqs/Filter'

const mapStateToProps = (state, props) => ({
  ...createAuthStateToProps(state, props),
  locationGroups: selectors.locationGroups.selectOptions(state),
  locations: selectors.locations.selectOptions(state),
  suppliers: selectors.suppliers.selectOptions(state, { itemsOnly: false }),
  users: selectors.users.selectOptions(state),
  tenants: selectors.tenants.selectOptions(state),
  customers: selectors.customers.selectOptions(state),
})

const mapDispatchToProps = (dispatch, props) => ({
  getLocationGroups: (params) => dispatch(locationGroupActions.getOptions(params)),
  getLocations: (params) =>
    dispatch(locationActions.getOptions({ ...params, active: 'All', locationVendingTypes: ['NonVending'] })),
  getSuppliers: (params) =>
    dispatch(
      supplierActions.getOptions({
        pageIndex: 1,
        pageSize: 100,
        ...params,
        active: 'All',
      }),
    ),
  getUsers: (params) => dispatch(userActions.getOptions({ ...params, active: 'All' })),
  getTenants: (params) => dispatch(tenantActions.getOptions(params)),
  getCustomers: (params) => dispatch(customerActions.getOptions(params)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
